module.exports = __webpack_public_path__ + "static/img/sec2-cont-sub02.53615a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/sec2-cont-sub02.png
// module id = QlFM
// module chunks = 0